// extracted by mini-css-extract-plugin
export default {"wallets":"KPFt4fbIEYgmzNM_hjCo"};